document.addEventListener('DOMContentLoaded', () => {
    const outtester = document.getElementsByClassName('scrolly');
    for (let i = 0; i < outtester.length; i++) {
        scrollification('scrolly', {
            i: i,
            scrollCont: '.carouselPre',
            itemsScroll: '.itemsC',
            customButtons: false, // Changed to false since buttons might not exist
            butLeft: '#left',
            butRight: '#right'
        });
    }

    function scrollification(mainConter, setup = {i, scrollCont, itemsScroll, customButtons, butLeft, butRight}) {
        let out;
        if (setup.i == null) {
            out = document.getElementsByClassName(mainConter)[0];
        } else {
            out = document.getElementsByClassName(mainConter)[setup.i];
        }

        const itemElements = out.querySelectorAll(setup.itemsScroll);
        const itemCount = itemElements.length;

        // Only try to access buttons if customButtons is true AND the buttons exist
        if (setup.customButtons === true) {
            const leftButton = out.querySelector(setup.butLeft);
            const rightButton = out.querySelector(setup.butRight);

            // Only proceed if both buttons exist
            if (leftButton && rightButton) {
                // Hide buttons if there are less than 4 items
                if (itemCount < 4) {
                    leftButton.style.display = 'none';
                    rightButton.style.display = 'none';
                }

                // Attach click handlers only if jQuery is available
                if (typeof $ !== 'undefined') {
                    $(leftButton).click(() => { getBack(); });
                    $(rightButton).click(() => { getNext(); });
                } else {
                    leftButton.addEventListener('click', getBack);
                    rightButton.addEventListener('click', getNext);
                }
            }
        }

        const scrollContainer = out.querySelector(setup.scrollCont);

        function getNext() {
            for (let i = 0; i < itemElements.length; i++) {
                if (itemElements[i].getBoundingClientRect().left <= scrollContainer.getBoundingClientRect().left + 600) {
                    const index = itemElements[i].offsetWidth;
                    if (typeof $ !== 'undefined') {
                        $(scrollContainer).scrollLeft($(scrollContainer).scrollLeft() + index);
                    } else {
                        scrollContainer.scrollLeft = scrollContainer.scrollLeft + index;
                    }
                    break;
                }
            }
        }

        function getBack() {
            for (let i = 1; i < itemElements.length; i++) {
                if (itemElements[i].getBoundingClientRect().left < scrollContainer.getBoundingClientRect().left + 600) {
                    const index = itemElements[i - 1].offsetWidth;
                    if (typeof $ !== 'undefined') {
                        $(scrollContainer).scrollLeft($(scrollContainer).scrollLeft() - index);
                    } else {
                        scrollContainer.scrollLeft = scrollContainer.scrollLeft - index;
                    }
                    break;
                }
            }
        }

        // Get all videos in the carousel
        const videos = out.querySelectorAll('.myVideo');
        
        // Function to pause all videos
        function pauseAllVideos() {
            videos.forEach(video => {
                video.pause();
            });
        }
        
        // Intersection Observer for videos - play only the most visible one
        const options = {
            root: null,
            rootMargin: '0px',
            threshold: [0.3, 0.5, 0.7, 0.9]  // Multiple thresholds to better track visibility
        };

        let currentlyPlayingVideo = null;
        let highestVisibilityRatio = 0;
        let mostVisibleVideo = null;

        const callback = (entries, observer) => {
            const isMobile = window.innerWidth <= 890;
            
            // First, find the most visible video
            highestVisibilityRatio = 0;
            mostVisibleVideo = null;
            
            entries.forEach(entry => {
                if (entry.intersectionRatio > highestVisibilityRatio) {
                    highestVisibilityRatio = entry.intersectionRatio;
                    mostVisibleVideo = entry.target;
                }
            });
            
            // Only if a video is 90% or more visible, make it the active one
            if (highestVisibilityRatio >= 0.9) {
                // If we have a new most visible video that's different from the currently playing one
                if (mostVisibleVideo && mostVisibleVideo !== currentlyPlayingVideo) {
                    // Pause any currently playing video
                    if (currentlyPlayingVideo) {
                        currentlyPlayingVideo.pause();
                    }
                    
                    // Check if the video has actual video sources before trying to play
                    const hasVideoSource = mostVisibleVideo.querySelector('source') !== null;
                    
                    // On mobile, play the most visible video automatically (but only if it has a source)
                    if (isMobile) {
                        // First pause all videos to ensure only one plays
                        pauseAllVideos();
                        
                        // Then play the most visible one only if it has a source
                        if (hasVideoSource) {
                            mostVisibleVideo.play().catch(e => console.log("Video play error:", e));
                            currentlyPlayingVideo = mostVisibleVideo;
                        }
                    } else {
                        // On desktop, set up hover behavior for the most visible video
                        if (!mostVisibleVideo.hasAttribute('hover-listeners-added')) {
                            mostVisibleVideo.setAttribute('hover-listeners-added', 'true');
                            
                            mostVisibleVideo.addEventListener("mouseover", () => {
                                pauseAllVideos();
                                // Only play if it has a source
                                if (hasVideoSource) {
                                    mostVisibleVideo.play().catch(e => console.log("Video play error:", e));
                                    currentlyPlayingVideo = mostVisibleVideo;
                                }
                            });
                            
                            mostVisibleVideo.addEventListener("mouseout", () => {
                                if (hasVideoSource) {
                                    mostVisibleVideo.pause();
                                }
                                currentlyPlayingVideo = null;
                            });
                        }
                    }
                }
            } else if (highestVisibilityRatio < 0.5 && currentlyPlayingVideo) {
                // If nothing is very visible, pause the currently playing video
                currentlyPlayingVideo.pause();
                currentlyPlayingVideo = null;
            }
        };

        const observer = new IntersectionObserver(callback, options);
        videos.forEach(video => observer.observe(video));
        
        // Handle scroll events to continually check video visibility
        if (scrollContainer) {
            scrollContainer.addEventListener('scroll', () => {
                // Process immediately during scroll for more responsive behavior
                observer.disconnect();
                videos.forEach(video => observer.observe(video));
                
                // And also after scrolling stops
                clearTimeout(scrollContainer.scrollTimer);
                scrollContainer.scrollTimer = setTimeout(() => {
                    observer.disconnect();
                    videos.forEach(video => observer.observe(video));
                }, 50);
            });
        }
    }

    // Handle mute/unmute functionality
    document.querySelectorAll('.soundButton').forEach(button => {
        const video = button.parentElement.querySelector('.myVideo');
        
        if (video) {
            // Set initial state
            video.setAttribute('muted', '');
            video.muted = true;
            button.innerHTML = '<i class="fas fa-volume-mute"></i>';
            button.classList.add('muted');
            
            button.onclick = function(e) {
                e.preventDefault();
                e.stopPropagation();
                
                if (video.hasAttribute('muted')) {
                    // Unmute
                    video.removeAttribute('muted');
                    video.muted = false;
                    button.innerHTML = '<i class="fas fa-volume-up"></i>';
                    button.classList.remove('muted');
                    console.log('Video unmuted');
                } else {
                    // Mute
                    video.setAttribute('muted', '');
                    video.muted = true;
                    button.innerHTML = '<i class="fas fa-volume-mute"></i>';
                    button.classList.add('muted');
                    console.log('Video muted');
                }
            };
        }
    });

    // Only try to access slogos if it exists
    const slogos = document.querySelector(".slogos");
    if (slogos) {
        const originalContent = slogos.innerHTML;
        slogos.innerHTML += originalContent;
        const singleSetWidth = slogos.scrollWidth / 2;
        const scrollSpeed = 50;
        const animationDuration = singleSetWidth / scrollSpeed;
        slogos.style.animationDuration = `${animationDuration}s`;
    }
});